<template>
  <ModalContainer queryParam="setDate" ref="modalContainer">

    <h3 class="modal-title">Programar Terapia</h3>

    <div class="my-2">
      <label for="fecha-ejecucion">Fecha Programación:</label>


      <input
        id="fecha-ejecucion"
        type="datetime-local"
        v-model="fechaProgramada"
        class="form-control"
      />


    </div>

    <b-row class="my-2 mt-3">

      <b-col class="d-flex justify-content-end">

        <b-button 
          variant="primary" 
          @click="programarTerapia"
        > 
          Programar 
        </b-button>
      </b-col>
      
    </b-row>

  </ModalContainer>

</template>

<script>
import { ModalContainer } from "@/shared/components"; 
import { terapiasService } from "../services";
import { terapiasMapper } from "../helpers";


export default {

  name: 'ModalProgramarTerapia',

  components: {
    ModalContainer,
  },


  data(){
    return{
      fechaProgramada: null,
      tokenTerapiaEnviada: null,
    }
  },


  created() {
    this.loadData();
  },

  methods: {

    async loadData(){

      this.fechaProgramada = null;
      this.tokenTerapiaEnviada = this.$route.query.setDate;

      if(!this.tokenTerapiaEnviada) return;

      const responseSearch = await terapiasService.getByToken(this.tokenTerapiaEnviada)

      if (!responseSearch.solicitudes) return;

      const terapiaMapped = terapiasMapper(responseSearch.solicitudes);
      console.log(terapiaMapped);

      this.fechaProgramada = terapiaMapped.fechaProgramada
    },


    async programarTerapia() {
      if(!this.tokenTerapiaEnviada) return;

      const confirmation = await this.$swal({
        title: "¿Estás seguro de programar esta fecha?",
        text: "No podrás deshacer esta acción.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, actualizar",
        cancelButtonText: "Cancelar",
      });

      if (!confirmation.isConfirmed) return;

      const fieldsToUpdate = {
        fechaProgramada: this.fechaProgramada
      }

      const responseSave = await terapiasService.updateByToken(this.tokenTerapiaEnviada, fieldsToUpdate);

      if (!responseSave) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Hubo un error en el servidor. Por favor, inténtalo de nuevo más tarde.",
        });

        return;
      } 

      await this.$swal({
        icon: "success",
        title: "Éxito",
        text: "La fecha se actualizó correctamente.",
      });

      this.$router.go(0);
    },


    

  },

  watch: {
    isVisible(newValue) {
      this.localIsVisible = newValue;
    },

    localIsVisible(newValue) {
      this.$emit('update:isVisible', newValue);
    },

    '$route.query.setDate': {
      handler(){
        this.loadData();
      },
    },
  }

}
</script>
